import React from "react";

function DeliveryAddressForm({
  deliveryAddress,
  setDeliveryAddress,
  deliveryCity,
  setDeliveryCity,
  deliveryState,
  setDeliveryState,
  deliveryZip,
  setDeliveryZip,
  theme,
}) {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: "500px",
      margin: "0 auto",
    },
    label: {
      color: theme.primaryFontColor,
      fontWeight: "600",
      fontSize: 13,
      marginBottom: 10,
      marginTop: -5,
    },
    input: {
      display: "block",
      width: "100%",
      marginBottom: "10px",
      padding: "7px",
      border: "1px solid #ccc",
      borderRadius: "5px",
    },
    addressRow: {
      justifyContent: "space-between",
      display: "flex",
    },
    cityStateZipRow: {
      gap: 10,
      display: "flex",
    },
    cityInput: {
      display: "block",
      width: "100%",
      marginBottom: "10px",
      padding: "7px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      flex: 2,
    },
    zipInput: {
      display: "block",
      width: "100%",
      marginBottom: "10px",
      padding: "7px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      flex: 1,
    },
    stateSelect: {
      display: "block",
      width: "100%",
      marginBottom: "10px",
      padding: "7px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      backgroundColor: "white",
      color: "black",
      flex: 1,
    },
  };

  const stateOptions = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
    "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
    "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
    "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
    "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ];

  return (
    <div style={styles.container}>
      <p style={styles.label}>Deliver To:</p>
      <div style={styles.addressRow}>
        <input
          type="text"
          value={deliveryAddress}
          onChange={(e) => setDeliveryAddress(e.target.value)}
          placeholder="Delivery Address"
          style={styles.input}
        />
      </div>
      <div style={styles.cityStateZipRow}>
        <input
          type="text"
          value={deliveryCity}
          onChange={(e) => setDeliveryCity(e.target.value)}
          placeholder="City"
          style={styles.cityInput}
        />

        <select
          value={deliveryState || ""}
          onChange={(e) => setDeliveryState(e.target.value)}
          style={styles.stateSelect}
        >
          <option value="" disabled>
            State
          </option>
          {stateOptions.map((state) => (
            <option key={state} value={state}>
              {state}
            </option>
          ))}
        </select>

        <input
          type="text"
          value={deliveryZip}
          onChange={(e) => setDeliveryZip(e.target.value)}
          placeholder="Zip"
          style={styles.zipInput}
        />
      </div>
    </div>
  );
}

export default DeliveryAddressForm;
